type LoadErrorStateProps = {
  message: string
  onRetry: () => void
  margin?: string
}

export default function LoadErrorState({ message, onRetry, margin = '32px' }: LoadErrorStateProps) {
  return (
    <div
      style={{
        margin,
        minHeight: '240px',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <div
        style={{
          width: 'min(520px, 100%)',
          background: '#FFFBF5',
          border: '1.5px solid #FCA5A5',
          borderRadius: '16px',
          padding: '28px',
          textAlign: 'center',
          boxShadow: '0px 2px 8px rgba(0,0,0,0.04)',
        }}
      >
        <p className="font-body" style={{ margin: '0 0 18px', fontSize: '14px', lineHeight: 1.6, color: '#991B1B' }}>
          {message}
        </p>
        <button
          type="button"
          className="font-body"
          onClick={onRetry}
          style={{
            border: 'none',
            background: '#D6B97B',
            color: '#0F2E2A',
            fontSize: '14px',
            fontWeight: 600,
            padding: '10px 22px',
            borderRadius: '10px',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    </div>
  )
}
